import React, { useState } from 'react'
import { useCustomer, useWishlist } from 'lib/core/hooks'
import { LoginModal } from 'lib/shared'
import { ReactComponent as WishlistSvg } from 'lib/core/resources/svg/heart.svg'
import { Container } from './styled'

interface Props {
  sku: string
}

export const AddToWishlist = ({ sku }: Props) => {
  const { handleRemoveFromWishlist, handleAddToWishlist, isAddedToWishlist, isLoading } = useWishlist(sku)
  const { isLoggedIn } = useCustomer()
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false)

  const handleAddItem = () => {
    if (!isLoggedIn) {
      setIsLoginModalVisible(true)
    } else {
      handleAddToWishlist()
    }
  }

  return (
    <>
      <Container
        isAdded={isAddedToWishlist}
        isLoading={isLoading}
        onClick={isAddedToWishlist ? handleRemoveFromWishlist : handleAddItem}
      >
        <WishlistSvg />
      </Container>

      {isLoginModalVisible && (
        <LoginModal
          isOpen
          handleCloseModal={() => setIsLoginModalVisible(false)}
          onLoginSuccess={() => {
            handleAddToWishlist()
            setIsLoginModalVisible(false)
          }}
        />
      )}
    </>
  )
}
